import { Controller } from '@hotwired/stimulus';

import { handleFloat } from '../models/helpers';

export default class extends Controller {
  static targets = ['section', 'input', 'output'];

  sectionTargets: HTMLElement[];

  connect() {
    this.sectionTargets.forEach(section => {
      this.updateSectionLabel(section);
    });
  }

  valueChanged() {
    this.sectionTargets.forEach(section => {
      this.updateSectionLabel(section);
    });
    this.triggerInputEvent();
  }

  updateSectionLabel(section: HTMLElement) {
    const label = section.querySelector(
      `[data-rollup-table-target="output"][data-section="${section.dataset.section}"]`
    );
    label!.innerHTML = this.totalForSection(section).toString();
  }

  triggerInputEvent() {
    const event = new Event('input');
    this.element.dispatchEvent(event);
  }

  totalForSection(section: HTMLElement) {
    const inputs = section.querySelectorAll<HTMLInputElement>('input[data-rollup-table-target="input"]');

    const total = Array.from(inputs)
      .map(input => {
        return Number(input.value) || 0;
      })
      .reduce((sum, value) => {
        return sum + value;
      });

    return handleFloat(total);
  }

  setValid(valid: boolean) {
    if (valid) {
      this.element.classList.remove('invalid');
    } else {
      this.element.classList.add('invalid');
    }
  }

  get inputs() {
    return this.element.querySelectorAll('input[data-rollup-table-target="input"]');
  }

  get values() {
    return Array.from(this.inputs).map(input => (input as HTMLInputElement).value);
  }
}
